// extracted by mini-css-extract-plugin
module.exports = {"mainImage":"styles_mainImage__2C3VA","title":"styles_title__30qnT","info":"styles_info__3FhJ4"};